import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresColaboradorConceptos', {
    template: template,
    controller: NominasNominaColaboradoresColaboradorConceptosComponent,
    bindings: {
      tipo: '@',
      conceptos: '<',
      data: '<',
      editable: '<',
      onChange: '&',
    },
  })

function NominasNominaColaboradoresColaboradorConceptosComponent() {
  let $ctrl = this

  $ctrl.actualizar = actualizar
  $ctrl.editando = false

  function actualizar(idConcepto, data) {
    if (data)
      $ctrl.data[$ctrl.tipo][idConcepto] = data
    else
      delete $ctrl.data[$ctrl.tipo][idConcepto]

    $ctrl.onChange({$event: {data: $ctrl.data}})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/colaborador/conceptos/component.js